import { HelpRounded } from "@mui/icons-material";
import {
  styled,
  Theme,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { Modal } from "@components";

interface Props {
  text: string | React.ReactElement;
  modalTitle?: string;
}

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    boxShadow: theme.shadows[1],
    fontSize: "14px",
    cursor: "pointer",
    pointerEvents: "auto",
  },
}));

export const SimpleHelpText: React.FC<Props> = ({ text, modalTitle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md"),
  );
  const [modalOpen, setModalOpen] = useState(false);

  if (isMobile) {
    return (
      <>
        <HelpRounded
          sx={{ color: theme.palette.text.secondary, cursor: "pointer" }}
          onClick={() => setModalOpen(true)}
        />
        <Modal
          title={modalTitle}
          content={text}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      </>
    );
  }

  return (
    <LightTooltip title={text} placement={"bottom-end"}>
      <HelpRounded sx={{ color: theme.palette.text.secondary }} />
    </LightTooltip>
  );
};
